import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styles } from "../../style/styles.js";
import { View, TextInput, TouchableOpacity, Text, Modal } from "react-native";
import { translateText } from "../../translations/translationService";
import { notify } from "../../services/ui/notify";

const FinishPieces = () => {
  const lang = useSelector((state) => state.lang.value);
  const [cantidad, setCantidad] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [comment, setComment] = useState("");
  const infoData = useSelector((state) => state.infoData.infoData);
  const dispatch = useDispatch();

  const handleCantidadChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, ""); // Solo valores numéricos
    setCantidad(numericValue);
  };

  const handleTerminarPiezas = () => {
    const cantidadNumeric = parseInt(cantidad);
    if (cantidadNumeric <= infoData.cantidad) {
      setShowModal(true);
    } else {
      // La cantidad ingresada supera la cantidad total de piezas
      notify.warn("La cantidad no puede ser mayor que la cantidad total de piezas.");
    }
  };

  const handleModalAccept = async () => {
    dispatch(/* Acciones a realizar al terminar las piezas */);
    await insertPiecesFinished(infoData.MO, cantidad);
    setCantidad("");
    setComment("");
    setShowModal(false);
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  return (
    <View style={styles.row}>
      <TextInput
        style={styles.inputFinishedPieces}
        value={cantidad}
        onChangeText={handleCantidadChange}
        keyboardType="numeric"
      />
      <TouchableOpacity
        style={styles.buttonPreStartProcess}
        onPress={handleTerminarPiezas}
      >
        <Text style={{ color: "white", textAlign: "center" }}>
          Terminar piezas
        </Text>
      </TouchableOpacity>

      <Modal visible={showModal} animationType="fade" transparent>
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Confirmar</Text>
            <TextInput
              style={[styles.modalTextSub, { backgroundColor: "black" }]}
              value={comment}
              onChangeText={setComment}
              placeholder={translateText("Comentario (opcional)", lang)}
            />
            <View style={styles.buttonModalContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonAccept]}
                onPress={handleModalAccept}
              >
                <Text style={styles.modalText}>Aceptar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonCancel]}
                onPress={handleModalCancel}
              >
                <Text style={styles.modalText}>Cancelar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default FinishPieces;
